var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnNew = function SvgIcnNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icn_new_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0a4 4 0 1 0 0 8h10a4 4 0 0 0 0-8H4Zm2.15 1.8v4.364h-.797L3.455 3.417h-.032v2.747H2.5V1.8h.81l1.883 2.744h.039V1.8h.918Zm.522 4.364V1.8h2.94v.76H7.595V3.6H9.46v.761H7.595v1.042H9.62v.76H6.672ZM9.84 1.8l1.248 4.364h.9l.828-2.853h.034l.831 2.853h.9L15.828 1.8H14.82L14.1 4.838h-.039L13.266 1.8h-.863l-.797 3.032h-.036L10.847 1.8H9.84Z",
    fill: "#FF5F2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icn_new_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v8H0z"
  })))));
};
export default SvgIcnNew;